import styled from 'styled-components';
import { TabPanel, Tabs } from '../../CommonComponents/OPL/Tab';
import { Box } from '../../CommonComponents/OPL/Box/Box';

export const StyledTabs = styled(Tabs)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'hidden',
});

export const StyledTabPanel = styled(TabPanel)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'hidden',
});

export const ScrollableContent = styled(Box)({
  overflowY: 'auto',
  padding: '24px 24px 40px',
});
